import { BaseCollection } from "../BaseCollection";
import { Delegator } from "../models/Delegator";

export const DelegatorCollection = BaseCollection.extend({
    model: Delegator,

    parse(resp) {
       resp.sellers = resp.data //Since we using new /api/delegators endpoint and there is no sellers field
       if (resp.hasOwnProperty("sellers")) {
           return resp.sellers;
       }

       return resp;
    },
});


// WEBPACK FOOTER //
// ./src/js/Xola/collections/Delegators.js